import React from 'react';
import { CalendarClockIcon } from 'lucide-react';
import { LAUNCH_DEADLINE, LAUNCH_DEADLINE_NEXT_DAY, REGULAR_PRICE } from '../data/offer';
export function Urgency() {
  return <section aria-labelledby="urgency-heading" className="w-full bg-sage" data-id="element-249" data-mp="1wznewz7w75oe">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12 sm:py-16 text-center" data-id="element-250" data-mp="1x1rhndu21yn3">
        <p id="urgency-heading" className="inline-flex items-center gap-2 text-white font-bold text-xs sm:text-sm uppercase tracking-[0.18em]" data-id="element-251" data-mp="21wnd6nyi344y">
          <CalendarClockIcon className="w-4 h-4 text-terracotta" aria-hidden="true" data-id="element-252" data-mp="1sylfoidz6tmf" />
          Prezzo di lancio — valido fino al {LAUNCH_DEADLINE}
        </p>

        <p className="mt-6 font-serif font-bold text-white text-2xl sm:text-4xl leading-snug" data-id="element-253" data-mp="1j7qrh8h65jyc">
          Dal {LAUNCH_DEADLINE_NEXT_DAY} il prezzo torna a {REGULAR_PRICE}.
        </p>

        <p className="mt-6 text-white/70 text-sm sm:text-base" data-id="element-254" data-mp="15alfkrurxqv6">
          Nessun conto alla rovescia che si azzera. La data è la stessa per
          tutti.
        </p>
      </div>
    </section>;
}